import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, withModifiers as _withModifiers, createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, Transition as _Transition, withCtx as _withCtx, normalizeStyle as _normalizeStyle, resolveDirective as _resolveDirective } from "vue"

const _hoisted_1 = { class: "view-button-parent" }
const _hoisted_2 = ["onClick"]
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "hide-mobile no-hover-area" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_RenderingRandselBag = _resolveComponent("RenderingRandselBag")!
  const _directive_touch = _resolveDirective("touch")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _withDirectives((_openBlock(), _createElementBlock("div", {
      class: "view-button-container",
      style: _normalizeStyle({ isOverlayVisible: _ctx.isVisible ? '105' : null }),
      onMouseover: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onMouseover && _ctx.onMouseover(...args))),
      onMouseleave: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.onMouseleave && _ctx.onMouseleave(...args)))
    }, [
      _createVNode(_Transition, { name: "slide-fade" }, {
        default: _withCtx(() => [
          _withDirectives(_createElementVNode("div", _hoisted_1, [
            (_openBlock(), _createElementBlock(_Fragment, null, _renderList(3, (i) => {
              return _createElementVNode("button", {
                key: i,
                class: "view-button",
                onClick: [
                  ($event: any) => (_ctx.onSetCameraPos(i - 1)),
                  _cache[0] || (_cache[0] = _withModifiers(() => {}, ["stop"]))
                ]
              }, [
                _createVNode(_component_RenderingRandselBag, {
                  cameraPos: i - 1,
                  isPreview: true
                }, null, 8, ["cameraPos"])
              ], 8, _hoisted_2)
            }), 64))
          ], 512), [
            [_vShow, _ctx.isVisible]
          ])
        ]),
        _: 1
      })
    ], 36)), [
      [
        _directive_touch,
        _ctx.onNext,
        "swipe",
        { left: true }
      ],
      [
        _directive_touch,
        _ctx.onPrev,
        "swipe",
        { right: true }
      ],
      [_directive_touch, _ctx.onTouch, "tap"]
    ]),
    _hoisted_3
  ], 64))
}